import { dayjs } from '@/api/utils/dayjs'

export function toISODate(value: string) {
  const [day, month, year] = value.split('.')
  return `${year}-${month}-${day}`
}

export function fromISODate(value: string) {
  const [year, month, day] = value.split('-')
  return `${day}.${month}.${year}`
}

export function toISOTime(value: string) {
  return value ? `${value}:00` : undefined
}

export function fromISOTime(value: string): string {
  const [hours, minutes] = value.split(':')
  return `${hours}:${minutes}`
}

export function formatWeekRange(startDate: string, endDate: string, short?: boolean) {
  const start = dayjs(startDate)
  const end = dayjs(endDate)

  const format = short ? 'D' : 'D MMMM'

  if (start.isSame(end, 'day')) {
    return start.format(format)
  }

  if (start.isSame(end, 'month')) {
    return `${start.format('D')} – ${end.format(format)}`
  }

  return `${start.format(format)} – ${end.format(format)}`
}

export function formatPeriodDates(startAt: string, endAt: string) {
  const start = dayjs(startAt)
  const end = dayjs(endAt)

  if (start.isSame(end, 'day')) {
    return start.format('D MMM').replace('.', '')
  }

  return `${start.format('D')}—${end.format('D MMMM').replace('.', '')}`
}
